import { axiosInstance } from 'utils/axiosInstance'
import { Route, UserInfo } from 'types/domain'

export const fetchCurrentUserInfo = async (): Promise<UserInfo> => {
  const response = await axiosInstance.get<UserInfo>('/users/me/userinfo')
  return response.data
}

export const fetchAuthorizedRoutes = async (): Promise<Route[]> => {
  const response = await axiosInstance.get<Route[]>(
    '/users/me/authorized_routes',
  )
  return response.data
}
